<template>
  <div>
    <div class="blue-subhead-bg text-uppercase">
      <h1>New Program Setup</h1>
    </div>
    <div class="container">
      <br>
      <div class="row">
        <br>
        <div
          v-if="!programId"
          class="alert alert-danger">
          Form progress has been interrupted. Please continue the creation process by finding the form in the dashboard or by starting a new one.
          <br>
          <router-link to="/admin/dashboard">Return to dashboard</router-link>
        </div>
        <transition name="fade">
          <div
            v-if="errors.length > 0"
            class="alert alert-danger"
          >
            <ul>
              <li v-for="(error, index) in errors" :key="index">{{error}}</li>
            </ul>
            <!-- <br>
            <router-link to="/admin/dashboard">Return to dashboard</router-link> -->
          </div>
        </transition>
        <div class="buttons">
          <a
            v-if="!!programId"
            href=""
            type="button"
            class="btn btn-default btn-lg text-uppercase col-sm-2 col-sm-offset-10"
            @click.prevent="cancelProgram"
          >
            Cancel
          </a>
        </div>
        <div v-if="step === 1" class="text-center">
          <div class="col-xs-12">
            <h1 class="text-uppercase">step 1</h1>
          </div>
          <div class="col-sm-6">
            <input v-model="programName" type="text" class="form-control admin-form-control input-lg" placeholder="Name of Program">
          </div>
          <div class="col-sm-6">
            <input v-model="programSlug" type="url" @keyup="checkErrors" class="form-control admin-form-control input-lg" placeholder="Url Endpoint">
            http://www.&lt;domain&gt;.com/program/<strong>{{ programSlug }}</strong>
          </div>
          <div class="col-sm-3">
            <select
              name=""
              id=""
              v-model="companySelected"
              @change="updateCompany"
              class="form-control admin-form-control input-lg">
              <option value="" disabled selected>Name of Company</option>
              <option
                v-for="(company, index) in companies" :key="index"
                :value="company._id">
                {{ company.name ? company.name.toUpperCase() : '' }}
              </option>
            </select>
          </div>
          <div class="col-sm-2">
            <button
              type="button"
              class="admin-btn-primary btn btn-lg btn-default form-control admin-form-control input-lg"
              @click="showCompanyModal = true">
              Add Company
            </button>
          </div>
          <div class="clearfix"></div>
          <div class="col-sm-4">
            <datepicker
              v-model="programStartDate"
              input-class="form-control admin-form-control input-lg"
              placeholder="Start Date"
            >
            </datepicker>
          </div>
          <div class="col-sm-4">
            <datepicker
              v-model="programEndDate"
              input-class="form-control admin-form-control input-lg"
              placeholder="End Date"
            >
            </datepicker>
          </div>
          <div class="clearfix"></div>
          <div class="col-sm-2">
            <div class="checkbox">
              <label for="">
                <input type="checkbox" name="" id="" v-model="programRequiresApproval">
                Users require approval
              </label>
            </div>
          </div>
        </div>

        <div v-if="step === 2" class="text-center">
          <div class="col-xs-12">
            <h1 class="text-uppercase">step 2</h1>
          </div>
          <br>
          <div class="col-sm-12">
            <h2 class="text-left">Rules</h2>
            <editor
              name="appendedOutput"
              :api-key="editorKey"
              :init="tinyOptions"
              v-model="programRules"
            ></editor>
          </div>
          <div class="col-sm-12">
            <h2 class="text-left">Terms &amp; Conditions</h2>
            <editor
              name="appendedOutput"
              :api-key="editorKey"
              :init="tinyOptions"
              v-model="programTerms"
            ></editor>
          </div>
        </div>

        <div v-if="step === 3">
          <form-builder />
        </div>

        <div v-if="step === 4">
          <div
            class="multi-sku">
            <div class="col-xs-12 text-center">
              <h1 class="text-uppercase">step 4: Rebate Items</h1>
              <br>
            </div>
            <csv-importer
              v-model="rebateItemsForm"
              :requiredFields="requiredFields"></csv-importer>
            <div
              class="set-searchable-fields"
              v-if="rebateItemsForm.csvHeaders"
              >
              <strong>Select searchable fields</strong>
              <div
                class="checkbox"
                v-for="(field, index) in rebateItemsForm.csvHeaders" :key="index"
                >
                <label for="">
                  <input
                    type="checkbox"
                    v-model="field.searchable"
                    >
                  {{ field.displayName }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div v-if="step === 5">
          <reward-item-form v-model="rewardItems"></reward-item-form>
        </div>

        <div v-if="step === 6">
          <div class="col-xs-12">
            <h1 class="text-uppercase">step 6: Training</h1>
            <br>
          </div>
          <div class="clearfix"></div>
          <div class="col-sm-6">
            <a
              href=""
              type="button"
              class="btn admin-btn-primary btn-lg btn-block text-uppercase"
              @click.prevent="goTraining">
              Yes
            </a>
            <br>
          </div>
          <div class="col-sm-6">
            <a
              href=""
              type="button"
              class="btn admin-btn-primary btn-lg btn-block text-uppercase"
              @click.prevent="next">
              No
            </a>
            <br>
          </div>
        </div>

        <div v-if="step === 7">
          <training-form v-model="trainings"></training-form>
        </div>

        <div class="clearfix"></div>
        <br><br>
        <div class="buttons">
          <a
            v-if="!!programId && step > 1"
            href=""
            type="button"
            :class="prevBtnClasses"
            @click.prevent="prev"
          >
            Previous
          </a>
          <a
            v-if="!!programId && step < 6 && !csvErrors && errors.length === 0"
            href=""
            type="button"
            :class="continueBtnClasses"
            @click.prevent="next"
          >
            Continue
          </a>
          <a
            v-if="!!programId && step === 7"
            href=""
            type="button"
            :class="continueBtnClasses"
            @click.prevent="next"
          >
            Finish
          </a>
        </div>
        <br>
      </div>

      <add-company-modal :showCompanyModal="showCompanyModal" v-on:close="showCompanyModal = false"></add-company-modal>

      <br>
      <br><br>
    </div><!-- container-fluid -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import Datepicker from 'vuejs-datepicker'
import FormBuilder from '../../components/admin/registrationForm/FormBuilder'
import CsvImporter from '../../components/CsvImporter'
import RewardItemForm from '../../components/admin/RewardItemForm'
import TrainingForm from '../../components/admin/TrainingForm'
import AddCompanyModal from '../../components/admin/AddCompanyModal'
import Editor from '@tinymce/tinymce-vue'

export default {
  name: 'NewProgramSetup',
  components: {
    Datepicker,
    'csv-importer': CsvImporter,
    'form-builder': FormBuilder,
    'reward-item-form': RewardItemForm,
    'training-form': TrainingForm,
    'add-company-modal': AddCompanyModal,
    editor: Editor
  },
  data () {
    return {
      categories: null,
      step: 1,
      errors: [],
      csvErrors: false,
      requiredFields: ['name', 'points'],
      skipRebate: true,
      skipTraining: true,
      singleSku: true,
      showCompanyModal: false,
      companySelected: '',
      newCompany: {
        name: null,
        logoUrl: null
      },
      rebateItemsForm: [],
      rewardItems: [],
      trainings: [],
      editorKey: '7bb76f8qmjwrxz0hn4kh6gyt3bs2fyk3pv7xavth6kcn3460',
      tinyOptions: {
        body_class: 'form-control admin-form-control input-lg',
        height: 300,
        menubar: false,
        toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright justify | numlist bullist outdent indent | forecolor | removeformat',
        plugins: ['lists']
      }
    }
  },
  mounted () {
    this.getCompanies()
      .catch(err => console.log(err))
  },
  watch: {
    rebateItemsForm: {
      handler: function () {
        this.setRebateItems()
        this.populateCategories()
      },
      deep: true
    },
    rewardItems: function () {
      this.setRewardItems()
    },
    trainings: function () {
      this.setTraining()
    }
  },
  computed: {
    ...mapState('loyaltyProgram', {
      state: state => state
    }),
    ...mapState('company', [ 'companies' ]),
    ...mapGetters('loyaltyProgram', [ 'programId' ]),
    continueBtnClasses () {
      let classes = 'btn admin-btn-primary btn-lg text-uppercase'
      if (this.step === 1) {
        classes += ' col-sm-4 col-sm-offset-4'
      } else {
        classes += ' col-sm-4 col-sm-offset-2'
      }
      return classes
    },
    prevBtnClasses () {
      let classes = 'btn admin-btn-primary btn-lg text-uppercase '
      if (this.step === 6) {
        classes += 'col-sm-4 col-sm-offset-4'
      } else {
        classes += 'col-sm-4 col-sm-offset-1'
      }
      return classes
    },
    programName: {
      get () {
        // const pattern = /^new-program-[\w]+$/i
        return this.state.program.name
      },
      set (value) {
        this.updateProgram({ prop: 'name', value })
      }
    },
    programCompany: {
      get () {
        return this.state.program.company ? this.state.program.company._id : ''
      }
    },
    programSlug: {
      get () {
        return this.state.program.slug
      },
      set (value) {
        this.updateProgram({ prop: 'slug', value })
      }
    },
    programStartDate: {
      get () {
        return this.state.program.startDate
      },
      set (value) {
        this.updateProgram({ prop: 'startDate', value })
      }
    },
    programEndDate: {
      get () {
        return this.state.program.endDate
      },
      set (value) {
        this.updateProgram({ prop: 'endDate', value })
      }
    },
    programRequiresApproval: {
      get () {
        return this.state.program.usersRequireApproval
      },
      set (value) {
        this.updateProgram({ prop: 'usersRequireApproval', value })
      }
    },
    programRules: {
      get () {
        return this.state.program.rules
      },
      set (value) {
        this.updateProgram({ prop: 'rules', value })
      }
    },
    programTerms: {
      get () {
        return this.state.program.terms
      },
      set (value) {
        this.updateProgram({ prop: 'terms', value })
      }
    },
    programCategories: {
      get () {
        return this.state.program.categories
      },
      set (value) {
        // console.log(value)
        this.updateProgram({ prop: 'categories', value })
      }
    },
    invalidUrl () {
      return !this.programSlug.match(/^([-a-z\d%_~]*)*$/) || this.programSlug === ''
    }
  },
  methods: {
    ...mapMutations('loyaltyProgram', {
      updateProgram: 'UPDATE_PROGRAM',
      updateProgramRebateItem: 'UPDATE_PROGRAM_REBATE_ITEM'
    }),
    ...mapActions('loyaltyProgram', [ 'saveProgram', 'deleteProgram', 'resetProgram' ]),
    ...mapActions('company', [ 'getCompanies', 'createCompany' ]),
    checkErrors () {
      this.errors = []
      if (this.invalidUrl) {
        this.errors.push('URL path may only contain numbers, letters, underscores, or dashes')
      }
    },
    cancelProgram () {
      if (!confirm('Are you sure you want to cancel this program?')) return

      this.deleteProgram(this.programId)
        .then(() => {
          this.resetProgram()
          this.$router.push({ name: 'AdminDashboard' })
        })
        .catch(err => {
          console.log(err)
        })
    },
    populateCategories () {
      if (this.rebateItemsForm.csvHeaders.find(head => head.field === 'category')) {
        this.categories = [
          ...this.rebateItemsForm.csv.reduce(
            (categorySet, csvRow) => {
              return categorySet.add(csvRow.category)
            },
            new Set()
          )
        ].map(cat => ({ category: cat }))
      }
      this.updateProgram({ prop: 'categories', value: this.categories })
    },
    save () {
      return new Promise((resolve, reject) => {
        this.saveProgram()
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    next () {
      /*
        SKIP SAVE
          - step 5 is an option for single/multiple skus
          - step 8 is to select yes or no for training
      */
      if (this.step > 0 && this.step < 5) { // For fields directly on loyalty program
        if (this.step === 1) {
          if (this.companySelected === '') {
            this.$bus.emit('notify', { message: 'Company must be set', type: 'danger' })
            return
          }
        }
        this.save()
          .then(() => {
            this.step++
          })
          .catch(err => {
            console.log(err)
            this.displayErrors('Unable to save program.')
          })
      } else if (this.step === 6) { // skip 9 if next on 8
        this.skipTraining ? this.finish() : this.step++
      } else if (this.step === 7) { // training
        this.finish()
      } else {
        this.step++
      }
    },
    prev () {
      this.step--
    },
    displayErrors (errors) {
      this.errors.push(errors)
      setTimeout(() => {
        this.errors = []
      }, 2500)
    },
    addCategory () {
      const categories = [...this.programCategories, '']
      this.updateProgram({ prop: 'categories', value: categories })
    },
    cancelCompany () {
      this.resetCompany()
      this.showCompanyModal = false
    },
    addCompany () {
      this.createCompany(this.newCompany)
        .then(() => {
          this.resetCompany()
          this.showCompanyModal = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    resetCompany () {
      this.newCompany = {
        name: null,
        logo: null
      }
    },
    updateCategory (index, event) {
      let source = { [index]: event.target.value }
      const categories = Object.assign([], this.programCategories, source)
      this.updateProgram({ prop: 'categories', value: categories })
    },
    updateCompany (event) {
      this.updateProgram({ prop: 'company', value: event.target.value })
    },
    updateRebateItem ({ index, prop, event }) {
      const value = event.target.value
      this.updateProgramRebateItem({ index, prop, value })
    },
    setRebateItems () {
      if (this.rebateItemsForm.errors.length > 0) { this.csvErrors = true; return }
      this.csvErrors = false
      this.updateProgram({
        prop: 'rebateItemFields',
        value: this.rebateItemsForm.csvHeaders
      })
      this.updateProgram({ prop: 'rebateItems', value: this.rebateItemsForm.csv })
    },
    setRewardItems () {
      this.updateProgram({ prop: 'rewardItems', value: this.rewardItems })
    },
    setTraining () {
      const clone = JSON.parse(JSON.stringify(this.trainings))
      this.updateProgram({ prop: 'loyaltyProgramTrainings', value: clone })
    },
    goSingleSku () {
      this.skipRebate = false
      this.updateProgramRebateItem({ index: 0, value: {} })
      this.next()
    },
    goMultipleSkus () {
      this.skipRebate = false
      this.singleSku = false
      this.next()
    },
    goTraining () {
      this.skipTraining = false
      this.next()
    },
    finish () {
      this.$bus.emit('global-load', { load: true, message: 'Saving Program', env: 'admin' })
      this.save()
        .then(() => {
          this.$bus.emit('global-load', { load: false })
          this.$router.push({ name: 'AdminDashboard' })
        })
        .catch(err => {
          console.log(err)
          this.$bus.emit('global-load', { load: false })
          this.displayErrors('Unable to save program.')
        })
    }
  }
}
</script>

<style scoped>
.modal-enter-active, .modal-leave-active {
  transition: opacity .5s;
}
.modal-enter, .modal-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.modal-mask {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 500px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #2F277A;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}
</style>
